/**
 * Check if URL belongs to localhost
 * @param url incoming URL
 * @returns `true` if URL belongs to `localhost`; `false` otherwise
 */
export function isLocalhost(url: string): boolean {
  // LOCALHOST CHECK
  const isLocalhost = /^https?:\/\/(localhost|127\.0\.0\.1):/.test(url);

  return isLocalhost;
}
